import type { FC } from 'react';
import React from 'react';
import type { EmployeeTypes } from 'types';

export const EmployeeCard: FC<EmployeeTypes.IStaffContact> = (props: EmployeeTypes.IStaffContact) => {
    const imageLoader = () => props.imageUrl ? <img src={props.imageUrl} alt={props.fullName} /> : '';

    return (
        <article className="fa-employees__card">
            <div className="fa-employees__card-image">{imageLoader()}</div>
            <div className="fa-employees__card-content-container">
                <div>
                    <h3 className="fa-employees__card-title fa-theme-color">{props.fullName}</h3>
                    <p className="fa-employees__card-job-title">{props.jobTitle}</p>
                </div>
                <div>
                    <p className="fa-employees__card-text">
                        <span>Phone:</span>
                        <a className="fa-employees__link" href={`tel:${props.phone}`}> {props.phone}</a>
                    </p>
                    <p className="fa-employees__card-text">
                        <span>Email:</span>
                        <a className="fa-employees__link" href={`mailto:${props.email}`}> {props.email}</a>
                    </p>
                </div>
            </div>
        </article>
    );
};
